/**
 * User `work_type_codes` 的「继承 / override」语义（复用 inheritCore，key=code）。
 *
 * 后端 `sys.user.work_type_codes` 是 JSONB NOT NULL DEFAULT '[]'：
 * - 空数组 ⇔ 继承所属 position 的 work types
 * - 非空数组 ⇔ 该用户自己的 override
 *
 * 「显式取空」无法与「继承」区分（空即继承），这是产品决策（empty = inherit）。
 */
import { resolveInherited, computeStoredInherited } from "./inheritCore";

export interface EffectiveWorkTypes {
  /** stored 为空 ⇒ 正在继承 position。 */
  inheriting: boolean;
  /** 实际生效的 work type codes（继承时 = position 的）。 */
  codes: string[];
}

/** 把存储值 + position 默认值解析成「生效集合 + 是否继承」。 */
export function resolveEffectiveWorkTypes(
  stored: string[] | null | undefined,
  positionWorkTypes: string[],
): EffectiveWorkTypes {
  const { inheriting, items } = resolveInherited(stored, positionWorkTypes);
  return { inheriting, codes: items };
}

/**
 * 把选中集合折算成要持久化的 `work_type_codes`：空 / 与 position 相等 → []（继承）；
 * 否则 → override 数组。
 */
export function computeStoredWorkTypes(
  selected: string[],
  positionWorkTypes: string[],
): string[] {
  return computeStoredInherited(selected, positionWorkTypes, (c) => c);
}
